import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import {TaskService} from '../../services/task.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { Subscription, BehaviorSubject, Observable } from 'rxjs';
import { debounceTime, map, switchMap } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import {UtilsModule} from '../../utils/utils.module';
@Component({
  selector: 'nf-multiple-person',
  templateUrl: './multiple-person.component.html',
  styleUrls: ['./multiple-person.component.css'],
  providers: [TaskService]
})
export class MultiplePersonComponent implements OnInit {
  dataSubscription: Subscription = null;
  boardData: any = {}; // 面板数据
  boardGroupData: Array<any> = []; // 面板组数据
  boardPulseData: Array<any> = []; // 面板列表数据
  boardColumnData: Array<any> = []; // 面板表头数据
  group: any = {}; // 当前组件分组数据
  pulse: any = {}; // 当前组件行数据
  column: any = {}; // 当前组件列数据
  inviteMailInputValue = ''; // 邀请成员组件绑定值
  inviteButtonState = true; // 邀请成员按钮可点击状态
  inviteMemberVisual = false; // 邀请成员表单可视状态
  personOption: Array<any> = [];  // 指派人组件下拉选项
  selectedPersonValue = []; // 指派人组件当前选中
  searchChange$ = new BehaviorSubject('');
  isLoading = false;
  randomUserUrl: string;
  isDisabled = false;
  selectedTags: Array<any> = []; // 存放所有选中的成员
  param: any = {}; // 存放请求参数
  btnConfirm = true;
  btnLoading = false;
  total: number;
  pageIndex = 1;
  pageSize = 10;
  searchKey;
  getBoardUserList: Observable<any>;
  loadMoreData = true;
  userData: Array<any> = [];
  popVisible = false;
  @Input('nfBoardData') set ChangeBoardData(data: any) {
    if (data) {
      this.boardData = data;
      this.boardGroupData = this.boardData.boardData.groups ? this.boardData.boardData.groups : [];
      this.boardColumnData = this.boardData.boardData.columns ? this.boardData.boardData.columns : [];
      this.boardPulseData = this.boardData.boardData.pulses ? this.boardData.boardData.pulses : [];
      this.userData = this.boardData.boardData.users ? this.boardData.boardData.users : [];
      // 人员添加默认颜色
      this.userData.forEach(item => {
        item.color = this.getAvatarColor();
      });
    }
  }
  @Input('nfGroupData') set ChangeGroupData(data: any) {
    if (data) {
      this.group = data;
    }
  }
  @Input('nfColumnData') set ChangeColumnData(data: any) {
    if (data) {
      this.column = data;
    }
  }
  @Input('nfPulseData') set ChangePulseData(data: any) {
    if (data) {
      this.pulse = data;
      this.selectedTags = [];
      // 增加头像随机颜色
      setTimeout(() => {
        if (this.pulse.columnValues[this.column.id] && this.pulse.columnValues[this.column.id].personsAndTeams) {
          this.pulse.columnValues[this.column.id].personsAndTeams.forEach(item => {
            this.selectedTags.push(item);
            this.userData.forEach(_i => {
              if (item.id === _i.id) {
                item.color = _i.color;
              }
            });
          });
        }
      }, 100);
    }
  }
  @Input('nfDisabled') set changeDisabled(val: boolean) {
    this.isDisabled = val;
  }
  @Output() updateFilterData: EventEmitter<any> = new EventEmitter<any>();
  constructor(
    private taskService: TaskService,
    private message: NzMessageService,
    private http: HttpClient,
    private utilsModule: UtilsModule
  ) { }

  ngOnInit() {
  }
  // 指派人组件-初始化选择列表
  initSelectOption() {
    this.onMemberSearch('');
  }
  // 下拉加载更多
  loadMore(): void {
    this.loadMoreData = false; // 关闭下拉加载
    if (this.loadMoreData) {
      this.randomUserUrl = this.taskService.getBoardUser(this.boardData.id);
      const param = {
        size: this.pageSize.toString(),
        page: this.pageIndex.toString()
      };
      this.getBoardUserList = this.http
        .get(`${this.randomUserUrl}`, {params: param})
        .pipe(map((res: any) => res))
        .pipe(
          map((list: any) => {
            return list;
          })
        );
      this.isLoading = true;
      this.getBoardUserList.subscribe(data => {
        this.isLoading = false;
        if (data) {
          const newData = data.users && data.users.data ? data.users.data : [];
          this.personOption = [...this.personOption, ...newData];
          if (this.pageIndex === data.users.page.totalPages) {
            this.loadMoreData = false;
            return;
          }
          this.pageIndex = data.users.page.number + 1;
        }
      });
    }
  }
  // 支持模糊搜索获取待选成员数据
  getBoardUserData() {
    this.randomUserUrl = this.taskService.getBoardUser(this.boardData.id);
    const getRandomNameList = (searchKey: string) =>
      this.http
        .get(`${this.randomUserUrl}`, {params: {searchKey}})
        .pipe(map((res: any) => res.users ? res.users.data : []))
        .pipe(
          map((list: any) => {
            return list;
          })
        );
    const optionList$: Observable<string[]> = this.searchChange$
      .asObservable()
      .pipe(debounceTime(500))
      .pipe(switchMap(getRandomNameList));
    optionList$.subscribe(data => {
      this.personOption = data;
      this.isLoading = false;
    });
  }
  // 模糊搜索
  onMemberSearch(value: string): void {
    this.isLoading = true;
    this.pageIndex = 1;
    const param = {
      size: '999',
      page: this.pageIndex.toString(),
      searchKey: value
    };
    this.taskService.getBoardUer(this.boardData.id, param).subscribe((res: any) => {
      if (res) {
        this.personOption = res.users ? res.users.data : [];
        this.isLoading = false;
      }
    });
    // this.isLoading = true;
    // this.searchChange$.next(value);
    // this.getBoardUserData();
  }
  // 指派人组件-控制邀请人状态
  inviteMember() {
    this.inviteMemberVisual = !this.inviteMemberVisual;
  }
  // 指派人组件-恢复初始状态
  clickChosePerson(data, pulseId, columnId) {
    this.initSelectOption();
    // 获取已选成员
    // this.getColumnsUserData(this.boardData.id, pulseId, columnId);
    this.inviteMemberVisual = false;
    // 获取默认选中指派人
    // this.selectedPersonValue = [];
    // if (data) {
    //   data.forEach((item, index) => {
    //     this.selectedPersonValue.push(item.id);
    //   });
    // }
  }
  // 指派人组件-受邀邮箱状态控制
  inviteMailKeyEvent(event) {
    const reg = new RegExp('^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\\.[a-zA-Z0-9_-]+)+$');
    if (reg.test(this.inviteMailInputValue)) {
      this.inviteButtonState = false;
    } else {
      this.inviteButtonState = true;
    }
  }
  // 指派人组件-发送邀请邮件
  doSendInvite() {
    const reg = new RegExp('^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\\.[a-zA-Z0-9_-]+)+$');
    if (reg.test(this.inviteMailInputValue)) {
      this.message.create('success', '发送成功！');
      this.inviteMemberVisual = false;
      this.inviteMailInputValue = '';
    } else {
      this.message.create('info', '请输入正确的邮箱！');
    }
  }
  // 指派人组件-选择指派人交互
  selectedPersonChange() {
    this.btnConfirm = !(this.selectedPersonValue && this.selectedPersonValue.length > 0);
    const param = {};
    const arr = [];
    if (!this.btnConfirm) {
      for (const item of this.selectedPersonValue) {
        const o = {
          'id': item.id,
          'name': item.name,
          'kind': 'person',
          'subscriberId': item.subscriberId,
          'photoUrl': item.photoUrl,
          'isOwner': item.isOwner,
          'isGuest': item.isGuest,
          'isViewOnly': item.isViewOnly,
          'isViewAll': item.isViewAll
        };
        arr.push(o);
      }
    }
    param['pulseIds'] = [this.pulse.id];
    param['columnId'] = this.column.id;
    param['columnValue'] = {
      'personsAndTeams': arr
    };
    this.param = param;
  }
  // 提交选中成员
  doSubmit() {
    this.btnLoading = true;
    const hash = {};
    const oldArr = this.param.columnValue.personsAndTeams.concat(this.selectedTags) as Array<any>;
    this.param.columnValue.personsAndTeams = oldArr.reduceRight((item: Array<any>, next) => {
      hash[next.id] ? '' : hash[next.id] = item.push(next);
      return item;
    }, []);
    this.patchColumnUser(this.boardData.id, this.pulse.id, this.column.id, this.param);
    if (this.param['columnId']) {
      this.pulse['columnValues'][this.param['columnId']]
        = this.param['columnValue'] ? this.param['columnValue'] : {personsAndTeams: []};
    }
    this.popVisible = false;
  }
  // 更新成员请求
  patchColumnUser(boardId, pulseId, columnId, param) {
    this.taskService.doEditPulse(boardId, param).subscribe((res: any) => {
      this.updateFilterData.emit();
      this.selectedPersonValue = [];
      this.btnLoading = false;
      // 获取已选成员
      // this.getColumnsUserData(this.boardData.id, pulseId, columnId);
      this.selectedTags = param.columnValue.personsAndTeams;
    }, (err) => {
      this.btnLoading = false;
    });
  }
  // 获取已选成员
  getColumnsUserData(boardId, pulseId, columnId) {
    this.dataSubscription = this.taskService.getColumnsUser(boardId, pulseId, columnId).subscribe((res: any) => {
      if (res) {
        this.selectedTags = res;
        this.selectedTags.forEach((item, index) => {
          this.selectedTags[index].kind = 'person';
        });
        // 更新指派人
        this.boardPulseData.forEach((item, index) => {
          if (item.id === pulseId) {
            for (const key in item.columnValues) {
              if (item.columnValues.hasOwnProperty(key)) {
                if (key === columnId) {
                  item.columnValues[key].personsAndTeams = this.selectedTags;
                  // 更新头像颜色
                  if (item.columnValues[key].personsAndTeams) {
                    item.columnValues[key].personsAndTeams.forEach(_item => {
                      this.userData.forEach(_i => {
                        if (_item.id === _i.id) {
                          _item.color = _i.color;
                        }
                      });
                    });
                  }
                }
              }
            }
          }
        });
      }
    });
  }
  // 删除已选成员
  handleClose(tag) {
    this.selectedTags.forEach((item, index) => {
      if (item.id === tag.id) {
        this.selectedTags.splice(index, 1);
      }
    });
    const param = {};
    param['pulseIds'] = [this.pulse.id];
    param['columnId'] = this.column.id;
    param['columnValue'] = {
      'personsAndTeams': this.selectedTags
    };
    this.param = param;
    this.patchColumnUser(this.boardData.id, this.pulse.id, this.column.id, this.param);
    this.boardPulseData.forEach(item => {
      if (item.id === this.pulse.id) {
        item.columnValues[this.column.id] = this.param.columnValue;
      }
    });
    this.btnConfirm = true;
  }
  getAvatarColor() {
    return this.utilsModule.getRandomColor();
  }
}
